import { canAccessDevHarness } from '@/utils/env'

const DEV_ONBOARDING_FORCE_KEY = 'lighthouse_dev_onboarding_force'

/** True when a harness account should see the onboarding rail anyway. */
export function isDevOnboardingForced(email: string | null | undefined): boolean {
    if (!canAccessDevHarness(email)) return false
    try {
        return sessionStorage.getItem(DEV_ONBOARDING_FORCE_KEY) === '1'
    } catch {
        return false
    }
}

export function setDevOnboardingForced(on: boolean): void {
    try {
        if (on) sessionStorage.setItem(DEV_ONBOARDING_FORCE_KEY, '1')
        else sessionStorage.removeItem(DEV_ONBOARDING_FORCE_KEY)
    } catch {
        // Private-mode storage failures just skip the preview lock.
    }
}
